import React from 'react'
import {
    Dialog as MuiDialog,
    DialogProps as MuiDialogProps,
    DialogTitle,
    DialogTitleProps,
    DialogContent,
    DialogContentProps,
    DialogActions,
    DialogActionsProps
} from '@mui/material'
import {makeStyles} from '@oc/styles'
import {SlideUp} from '@oc/shell-core'
import {useExtractedClassName} from '@oc/hooks'
import {DataCyProps} from './dataCyProps'

const useStyles = makeStyles(theme => ({
    dialogHeader: {
        borderBottom: `1px solid ${theme.palette.divider}`
    }
}))

interface DialogProps extends DataCyProps, React.PropsWithChildren {
    open: boolean
    title: React.ReactNode
    square?: boolean
    actions: React.ReactNode
    dialogProps?: Omit<MuiDialogProps, 'open'>
    titleProps?: DialogTitleProps & DataCyProps
    contentProps?: DialogContentProps & DataCyProps
    actionProps?: DialogActionsProps & DataCyProps
}

export function Dialog(props: DialogProps) {
    const {classes} = useStyles()

    const [headerClassName, restCardProps] = useExtractedClassName(classes.dialogHeader, props.titleProps)

    return (
        <MuiDialog
            open={props.open}
            data-cy={props['data-cy']}
            TransitionComponent={SlideUp}
            PaperProps={{square: props.square}}
            {...props.dialogProps}
        >
            <DialogTitle className={headerClassName} {...restCardProps}>
                {props.title}
            </DialogTitle>
            <DialogContent {...props.contentProps}>{props.children}</DialogContent>
            <DialogActions {...props.actionProps}>{props.actions}</DialogActions>
        </MuiDialog>
    )
}
